import React, { FunctionComponent, useEffect } from 'react'
import { Country } from '@afterpay/types'
import { Heading, useIsBreakpointLargeAndUp } from '@afterpaytouch/core'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { usePostLoginRoute } from '../../config/router'
import { useAppRouter, useConsumerLendingEligible, useCountry, useCreateFacilityAssessmentMutation } from '../../state'
import styles from './style.module.css'
import { ApprovedCreditHeader } from './Header'
import { ApprovedCreditLimit } from './CreditLimit'
import { ApprovedCreditInterestRate } from './InterestRate'
import { ApprovedCreditFooter } from './Footer'
import { useCheckoutSizes } from '../../utils/responsive'

export const ApprovedCredit: FunctionComponent = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const postLoginRoute = usePostLoginRoute()
  const country = useCountry()
  const consumerLendingEligible = useConsumerLendingEligible()
  const isDesktop = useIsBreakpointLargeAndUp()
  const { sectionHeadingSize } = useCheckoutSizes()
  const [_, { data: facilityAssessmentData }] = useCreateFacilityAssessmentMutation({ fixedCacheKey: 'shared-facility-assessment' })
  const { facilityLimit, aprRangeMax, aprRangeMin, creditContractDocumentId } = facilityAssessmentData ?? {}

  const pageClassNames = clsx(styles.approvedCreditPage, (isDesktop ?? false) && styles.approvedCreditPageDesktop)

  useEffect(() => {
    if (!consumerLendingEligible || country !== Country.AU) {
      router.push(postLoginRoute)
    }
  }, [country, consumerLendingEligible, router, postLoginRoute])

  return (
    <div className={pageClassNames}>
      <ApprovedCreditHeader creditLimit={facilityLimit} />
      <div className={styles.approvedCreditBody}>
        <div className={styles.approvedCreditBodyPadding}>
          <Heading size={sectionHeadingSize}>{t('consumerLending:approvedCredit:detailsHeading')}</Heading>
          <ApprovedCreditLimit creditLimit={facilityLimit} />
          <ApprovedCreditInterestRate aprMax={aprRangeMax} aprMin={aprRangeMin} />
          <ApprovedCreditFooter contractId={creditContractDocumentId} />
        </div>
      </div>
    </div>
  )
}
